import React from "react";
import Sidebar from "../components/sidebar";
import Header from "../components/Header";
import PaymentsMain from "../components/odero/PaymentsMain";
const OderoSearchScreen = () => {
  return (
    <>
      <Sidebar />
      <main className="main-wrap">
        <Header />
        <PaymentsMain/>
      </main>
    </>
  );
};
export default OderoSearchScreen;
